(function(global){
 'use strict';
 function buildLink(page,params={},context={}){
  const query=new URLSearchParams(params);
  const root=context.root||'/';
  if(context.isTheme&&page==='product'){
   const product=context.products?.[params.item];
   if(!product)return root+'collections/all';
   const variant=params.sku?product.variants?.[params.sku]:params.variant;
   const knownVariant=variant&&Object.values(product.variants||{}).includes(String(variant));
   const nativeQuery=new URLSearchParams();
   if(knownVariant)nativeQuery.set('variant',variant);
   if(context.previewThemeId)nativeQuery.set('preview_theme_id',context.previewThemeId);
   return root+'products/'+encodeURIComponent(product.handle)+(nativeQuery.size?'?'+nativeQuery:'');
  }
  if(context.isTheme){
   if(page!=='index')query.set('view',page);
   if(context.previewThemeId)query.set('preview_theme_id',context.previewThemeId);
   return root+(query.size?'?'+query:'');
  }
  return page+'.html'+(query.size?'?'+query:'');
 }
 if(typeof module==='object'&&module.exports)module.exports={buildLink};
 else global.SUCI_buildLink=buildLink;
})(typeof window==='object'?window:globalThis);
